export enum RequestStatus {
  Ready = 'READY',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}
